import React, { useEffect, useState } from 'react';
import DateDisplay from "../DateDisplay";
import QuoteService from "../../services/QuoteService";
import Api from "../../services/Api";
import StatusHelper from "../../helpers/StatusHelper";
import Notifications from "../../services/Notifications";
import PDFIcon from "../icons/OrderAckIcon";
import { withRouter } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import { ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import TranslatableDataGrid from '../shared/TranslatableDataGrid';
import StorefrontAdminTheme from '../shared/MUIStyles/StorefrontAdminTheme';
import { useStorefrontAdministrationConfig } from '../../hooks/StorefrontAdministrationConfigContext';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Loading from '../Loading';
import ModalPopup from "../../services/ModalPopup";

const QuoteLines = (props) => {
    const localized = props?.localized;
    const [rows, setRows] = useState([]);
    const [convertingQuote, setConvertingQuote] = useState(false);
    const [convertedQuote, setConvertedQuote] = useState(false);
    const [documentNumber, setDocumentNumber] = useState(null);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [openConvertModal, setOpenConvertModal] = useState(false);
    const selectedCustomer = props.selectedCustomer ? props.selectedCustomer : null;
    const customerId = selectedCustomer ? selectedCustomer.id : null;
    const implementationId = props.storefrontConfig.storefront.implementationId;
    const documentCompany = selectedCustomer ? selectedCustomer.companyCode : null;
    const [convertPO, setConvertPO] = useState("");
    const [convertComment, setConvertComment]= useState("");
    const [confirmationOptions, setConfirmationOptions] = useState({
        show: false,
        message: "",
    });

    const theme = StorefrontAdminTheme;
    const gridLocalized = useStorefrontAdministrationConfig().labels;

    useEffect(() => {
        if (!openConvertModal) {
            getQuotes();
        }
    }, [props.quotes, openConvertModal]);

    const getQuotes = () => {
        if (props.quotes === null) {
            props.fetchOrders();
        }
        if (props.quotes) {
            mapOrderlinesToOrders(props.quotes);
        }
    }

    const mapOrderlinesToOrders = (quoteLines) => {
        var rows = [];
        quoteLines.forEach((quoteLine, index) => {
            rows.push({
                id: index,
                submittedOn: quoteLine.submittedOn,
                poNumber: quoteLine.referenceNumber,
                status: quoteLine.quoteStatus,
                quoteNumber: `${quoteLine.orderId} ${quoteLine.orderType}`,
                orderId: quoteLine.orderId,
                orderType: quoteLine.orderType,
                convertedToOrder: quoteLine.convertedToOrder,
            });
        });
        setRows(rows);
    };
    const viewQuote = (quote) => {
        props.history.push({
            pathname:
                "/quote/" +
                quote.orderId +
                "/" +
                props.selectedCustomer.companyCode +
                "/" +
                quote.orderType,
        });
    };

    const hideConfirmation = () => {
        setConfirmationOptions({ show: false });
    };

    const handleRejectClick = (documentNumber) => {
        hideConfirmation();
        props.setFetching(true);
        return QuoteService.rejectQuote(
            documentNumber,
            documentCompany,
            customerId,
            implementationId
        ).then(handleQuoteRejectResponse);
    };

    const handleQuoteRejectResponse = (response) => {
        if (response) {
            getQuotes();
            Notifications.message(props.localized.QuoteRejected);
        }
        else {
            Notifications.error(props.localized.QuoteNotRejected);
            props.setFetching(false);
        }
    };

    const rejectQuoteConfirmation = (documentNumber) => {
        setConfirmationOptions(prevObject => 
            ({...prevObject, show: true, message: props.localized.QuoteRejectWarning,
            callback: () => {
                handleRejectClick(
                    documentNumber
                );
            },
        }));

    }
    const editQuote = (quoteId) => {
        let key = `${quoteId}-${documentCompany}000SQ`;
        props.history.push(`/quote/edit/${key}`);
    };

    const handleConvertToOrderConfirmation = async (form)=> {
        var convertQuoteToOrderData = {
            documentNumber: form.orderId,
            documentCompany: form.orderCompany,
            customerPO: form.poNumber,
            comments: form.comments,
            customerId: customerId,
            implementationId: implementationId
        };
        hideConfirmation();
        setConvertingQuote(true);
        setDocumentNumber(form.orderId);

        await QuoteService.convertQuoteToOrder(convertQuoteToOrderData).then((res) => {
            if (res) {
                Notifications.message(props.localized.YourQuoteIsBeingConverted);
                setDocumentNumber(res.documentNumber);
                setConvertingQuote(false);
                setConvertedQuote(true);
                props.hideQuotesFilter(true);
                props.history.push({
                    pathname: "/cart/confirmation",
                    state: { IsQuote: false, DocumentNumber: res.documentNumber },
                });
            } else {
                Notifications.error(
                    "Order could not be placed.Please contact sales representative"
                );
                setConvertingQuote(false);
            }
        });
    };

    const getComments = async (row) => {
        return await Api.fetch(`/api/orders/getCommentsBySale/${row.orderId}/${documentCompany}/${row.orderType}`)
            .then((res) => {
                if (res) {
                    setSelectedRow({ ...row, comments: res });
                    setConvertComment(res);
                    
                }
                else {
                    setSelectedRow({ ...row, comments: "" });
                    setConvertComment("");
                }                
                setConvertPO(row.poNumber ?? "");
                setOpenConvertModal(true);
            }            
        );
    }
    const convertQuoteToOrder = async (form) => {
        props.setFetching(true);
        await handleConvertToOrderConfirmation(form);
        getQuotes();
    };

    const getPDF = (orderNumber, orderType) => {
        Api.downloadFileName(`/api/orders/GetPDF/${props.selectedCustomer.billToId}/${orderNumber}/${orderType}`,
            `${props.selectedCustomer.billToId}-${orderNumber}${orderType}`)
            .then(handleError);
    };

    const handleError = (res) => {
        if (!res) Notifications.error(localized.NoPDFMessage);
    };

    const handleChangeConvertPO = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setConvertPO(e.target.value);
    }

    const handleChangeConvertComment = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setConvertComment(e.target.value);
    }

    const handleClickOpenConvertModal = async (e, row) => {
        e.stopPropagation();
        await getComments(row);
    }

    const handleCloseConvertModal = () => {
        setOpenConvertModal(false);
    }

    const renderConvertModal = (row) => {        
            return (
                <>
                    <Dialog
                        open={openConvertModal}
                        onClose={handleCloseConvertModal}
                        PaperProps={{
                            component: 'form',
                            onSubmit: (event) => {
                                event.preventDefault();
                                const formData = new FormData(event.currentTarget);
                                formData.append("id", row.id);
                                formData.append("orderId", row.orderId);
                                formData.append("orderCompany", documentCompany);
                                const formJson = Object.fromEntries(formData.entries());
                                convertQuoteToOrder(formJson);
                                handleCloseConvertModal();
                            },
                        }}
                    >
                        <DialogTitle><h1>{localized.ConvertToOrder}</h1></DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <h3>{localized.ValuesEligibleForUpdateBelow}</h3>
                            </DialogContentText>
                            <TextField
                                defaultValue={row.poNumber}
                                inputProps={{ maxLength: props.storefrontConfig.settingsList.MaxPOLength }}
                                margin="dense"
                                id="poNumber"
                                name="poNumber"
                                label={localized.PONumber}
                                type="text"
                                fullWidth
                                variant="standard"
                                required
                                helperText={`${convertPO.length}/${props.storefrontConfig.settingsList.MaxPOLength}`}
                                onChange={handleChangeConvertPO}
                                value={convertPO}
                            />
                            <TextField
                                defaultValue={row.comments}
                                inputProps={{ maxLength: 250 }}
                                margin="dense"
                                id="comments"
                                name="comments"
                                label={localized.Comments}
                                type="text"
                                fullWidth
                                variant="standard"
                                multiline
                                rows={4}
                                onChange={handleChangeConvertComment}
                                value={convertComment}
                                helperText={`${convertComment.length}/250`}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button variant="standard" color="error" onClick={handleCloseConvertModal}>{localized.Cancel}</Button>
                            <Button variant="standard" color="update" type="submit">{localized.ConvertToOrder}</Button>
                        </DialogActions>
                    </Dialog>
                </>
            )
    }

    const columns = [
        {
            field: 'submittedOn',
            headerName: props.localized.QuoteDate,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <DateDisplay date={params.row.submittedOn} dateFormat={props.dateFormat} />
                )
            },
        },
        {
            field: 'quoteNumber',
            headerName: props.localized.QuoteNumber,
            headerAlign: 'left',
            flex: 0.2
        },
        {
            field: 'status',
            headerName: localized.Status,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{ color: '#38b25f' }}>
                        <h5>{StatusHelper.formatQuoteStatus(params.row.status, localized)}</h5>
                    </div>
                )
            },
            flex: 0.1
        },
        {
            field: 'poNumber',
            headerName: localized.PONumber,
            headerAlign: 'left',
            renderCell: (params) => {
                { params.row.poNumber }
            },
            flex: 0.2
        },
        {
            field: '',
            headerName: "PDF",
            headerAlign: 'left',
            renderCell: (params) => {               
                return (
                    props.downloadQuotePDF && (
                        <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                               getPDF(params.row.orderId, params.row.orderType);
                        }}
                        title={localized.DownloadPDF}
                    >
                        <PDFIcon />
                        </div>
           )) },
        },
        {
            field: ' ',
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    props.rejectQuoteEnabled && (<Button variant="standard" color="update"
                        onClick={() =>
                            rejectQuoteConfirmation(
                                params.row.orderId,
                                props.selectedCustomer.companyCode,
                                props.selectedCustomer.id,
                                props.storefrontConfig.storefront.implementationId
                            )
                        } disabled={params.row.convertedToOrder}>{localized.Reject}</Button>)
                )
            },
            disableClickEventBubbling: true
        },
        {
            field: '  ',
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <Button variant="standard" color="update" onClick={() => viewQuote(params.row)}>{localized.ViewDetails}</Button>
                )
            },
        },
        {
            field: '   ',
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    props.convertQuoteEnabled && (
                        <Button
                            variant="standard" color="update"
                            onClick={(e) => handleClickOpenConvertModal(e, params.row)}
                            disabled={params.row.convertedToOrder}
                        >                            
                            {(convertingQuote && documentNumber === params.row.orderId) ? <CircularProgress style={{ color: 'white' }} size={24} /> : localized.ConvertToOrder}
                        </Button>)
                )
            },
            flex: 0.2
        },
        {
            field: '     ',
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    props.editQuoteEnabled && (<Button variant="standard" color="update" disabled={params.row.convertedToOrder}
                        onClick={() => editQuote(params.row.orderId, props.selectedCustomer.companyCode)}>{localized.EditQuote}</Button>)
                )
            },
            flex: 0.2
        },
    ];


    return (
        <>  
            {props.fetching && <Loading type="brand" />}
            {
                !convertedQuote && !props.fetching && (gridLocalized && Object.keys(gridLocalized).length > 0) &&
                <>
                    <ThemeProvider theme={theme}>
                        <Paper sx={{
                            height: 700,
                            width: '100%'
                        }}>
                            <TranslatableDataGrid
                                rows={rows}
                                columns={columns}
                                fetching={props.fetching}
                                labels={gridLocalized}
                                square={true}
                            />
                        </Paper>
                    </ThemeProvider>
                    <ModalPopup
                        {...confirmationOptions}
                        onHide={hideConfirmation}
                    />
                    {openConvertModal && renderConvertModal(selectedRow)}
                </>
            }
        </>
    );

};
export default withRouter(QuoteLines);
